module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_9005.5cdf17d8.png";